module.exports = __webpack_public_path__ + "img/up_res_system.96fe5b76.svg";